<template>
  <div
    class="nav-bar-content"
    v-if="statusBarHeight"
    :class="{ 'nav-bar-opacity1': opacity == 1 }"
    :style="{
      height: height + 'px',
      paddingTop: statusBarHeight + 'px',
      backgroundColor: 'rgba(255,255,255,' + opacity + ')',
      color: mainColor
    }"
  >
    <div class="back" @click="bindBack"><i class="iconfont icon-you"></i></div>
    <div class="title">{{ type == 'list' ? '门店列表' : '门店详情' }}</div>
    <div class="select-city" @click="bindSelectCity" v-if="type == 'list'"
      >切换城市
      <i class="iconfont icon-shiyuanjiaosanjiao"></i>
    </div>
    <div class="share" @click="bindShare" v-else-if="type == 'detail'"
      ><i class="iconfont icon-fenxiang11"></i
    ></div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'list'
    },
    opacity: {
      type: Number,
      default: 0
    }
  },
  components: {},
  data() {
    return {
      statusBarHeight: 0,
      height: 0
    }
  },
  computed: {
    mainColor() {
      return this.opacity <= 0.5 ? '#fff' : '#000'
    }
  },
  watch: {
    opacity() {}
  },
  created() {
    this.getBottomContentHeight()
  },
  methods: {
    getButtonColor(opacity) {
      return 'rgba(0,0,0,' + (opacity <= 0.5 ? 0.5 : 0.5 - 0.5 * opacity) + ')'
    },
    bindBack() {
      this.$http.appBack()
    },
    bindShare() {
      this.$emit('share')
    },
    bindSelectCity() {
      this.$emit('selectCity')
    },
    async getBottomContentHeight() {
      if (this.$betterwe.isApp()) {
        let res = await this.$betterwe.getAppBarHeight().catch(() => {})
        if (res) {
          this.statusBarHeight = res.statusBarHeight
          this.height = this.statusBarHeight + res.toolsBarHeight
        }
      } else {
        this.statusBarHeight = 40
        this.height = this.statusBarHeight + 28
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.nav-bar-content {
  position: fixed;
  width: 100%;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  z-index: 66;
  color: #fff;
  transition: all 0.3s ease;
  .title {
    width: 100%;
    box-sizing: border-box;
    padding-left: 44px;
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 18px;
    font-weight: 600;
    text-align: left;
  }
  .back,
  .share,
  .select-city {
    font-weight: bold;
    position: absolute;
    display: flex;
    align-items: center;
  }
  .back {
    left: 16px;
    .icon-you {
      display: block;
      font-size: 22px;
      transform: rotate(180deg);
      position: relative;
      bottom: -2px;
    }
  }
  .select-city {
    right: 16px;
    .iconfont {
      font-size: 8px;
      margin-left: 5px;
    }
  }
  .share {
    right: 20px;
    .icon-fenxiang11 {
      font-weight: normal;
      font-size: 24px;
    }
  }
}
.nav-bar-opacity1 {
  .share,
  .back {
  }
}
</style>
